import AiAssistantIcon from '~/assets/ai-assistant-icon.svg?react';
import AssistanceIcon from '~/assets/assistance-icon.svg?react';
import ChatAndSearchIcon from '~/assets/chat-and-search-icon.svg?react';
import ChatIcon from '~/assets/chat-icon.svg?react';
import ChevronDownIcon from '~/assets/chevron-down.svg?react';
import FaqIcon from '~/assets/faq-icon.svg?react';
import InteractiveSearchIcon from '~/assets/interactive-search-icon.svg?react';
import SearchIcon from '~/assets/search-icon.svg?react';

import type { ButtonIconName } from '@worknet/models';

export function ButtonIcon({ name, className }: { name: ButtonIconName; className?: string }) {
  switch (name) {
    case 'chat':
      return <ChatIcon className={className} />;
    case 'search':
      return <SearchIcon className={className} />;
    case 'assistance':
      return <AssistanceIcon className={className} />;
    case 'ai-assistant':
      return <AiAssistantIcon className={className} />;
    case 'chat-and-search':
      return <ChatAndSearchIcon className={className} />;
    case 'interactive-search':
      return <InteractiveSearchIcon className={className} />;
    case 'faq':
      return <FaqIcon className={className} />;
    case 'chevron-down':
      return <ChevronDownIcon className={className} />;
    case 'none':
    default:
      return null;
  }
}
